import ExcelJS from "exceljs"
export const downloadFile = (data, fileName) => {
  const url = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

export const downloadPDF = (data) => {
  const blob = new Blob([data], {
    type: "application/pdf",
  });
  const url = window.URL.createObjectURL(blob);
  const w = window.open(url);
  w.print();
  window.URL.revokeObjectURL(url);
};

export const downloadPDF2 = (data, fileName = "document.pdf") => {
  // 1. 创建 Blob 对象
  const blob = new Blob([data], {
    type: "application/pdf",
  });

  // 2. 创建一个指向该 Blob 的 URL
  const url = window.URL.createObjectURL(blob);

  // 3. 创建一个隐藏的 <a> 标签
  const link = document.createElement("a");
  link.href = url;

  // 4. 设置下载文件的名称
  link.download = fileName;

  // 5. 触发点击事件
  document.body.appendChild(link);
  link.click();

  // 6. 清理：移除标签并释放 URL 对象
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

export const getFileName = (module, customerCode) => {
  const date = new Date();
  const date_ = date.toLocaleDateString().split("/");
  return `${module}_${customerCode}_${date_[0]}${date_[1]}${date_[2]}`;
};

export const downloadExcel = async (filename, data) => {
  if (!data || data.length === 0) return;

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Export");

  const firstItem = data[0];
  worksheet.columns = Object.keys(firstItem).map((key) => ({
    header: key,
    key: key,
    width: key.length < 10 ? 15 : key.length + 5,
  }));

  worksheet.addRows(data);

  const buffer = await workbook.xlsx.writeBuffer();

  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `${filename}.xlsx`;

  document.body.appendChild(link);
  link.click();

  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};
